var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content w3-padding",staticStyle:{"max-width":"1564px"}},[_c('Events'),_c('Sound'),_c('About')],1)}
var staticRenderFns = []

export { render, staticRenderFns }